var _i = Object.defineProperty;
var Oi = (e, t, r) => t in e ? _i(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ge = (e, t, r) => (Oi(e, typeof t != "symbol" ? t + "" : t, r), r);
import { pushScopeId as Si, popScopeId as xi, nextTick as Jt, openBlock as z, createBlock as Ve, withScopeId as Ti, markRaw as Ei, shallowReactive as Ai, resolveComponent as Ci, resolveDirective as $i, withDirectives as ki, createElementBlock as F, normalizeClass as Qe, renderSlot as Te, createCommentVNode as ze, resolveDynamicComponent as vr, normalizeStyle as Ot, withCtx as St, Fragment as Br, renderList as Nr, mergeProps as Di, toHandlers as Li, createVNode as xt, computed as H, defineComponent as Dt, watch as Tt, createElementVNode as X, withModifiers as zt, unref as ye, toDisplayString as Et, getCurrentInstance as Ii, ref as yt, onMounted as Mi, onBeforeUnmount as Vi, render as zi } from "vue";
import B from "lodash";
import { useI18n as Qt } from "vue-i18n";
import hr from "@patsnap-biz/icon";
import Pi from "@patsnap-ui/icon/assets/solid/DropdownRight.svg";
import ji from "@patsnap-ui/icon/assets/solid/DropdownOpen.svg";
import Ri from "@patsnap-ui/icon/assets/solid/SmallDot.svg";
function Bi() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var r = e.indexOf("Trident/");
  if (r > 0) {
    var i = e.indexOf("rv:");
    return parseInt(e.substring(i + 3, e.indexOf(".", i)), 10);
  }
  var n = e.indexOf("Edge/");
  return n > 0 ? parseInt(e.substring(n + 5, e.indexOf(".", n)), 10) : -1;
}
let bt;
function Ht() {
  Ht.init || (Ht.init = !0, bt = Bi() !== -1);
}
var Lt = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    Ht(), Jt(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", bt && this.$el.appendChild(e), e.data = "about:blank", bt || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!bt && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Ni = /* @__PURE__ */ Ti("data-v-b329ee4c");
Si("data-v-b329ee4c");
const Hi = {
  class: "resize-observer",
  tabindex: "-1"
};
xi();
const Wi = /* @__PURE__ */ Ni((e, t, r, i, n, a) => (z(), Ve("div", Hi)));
Lt.render = Wi;
Lt.__scopeId = "data-v-b329ee4c";
Lt.__file = "src/components/ResizeObserver.vue";
function wt(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? wt = function(t) {
    return typeof t;
  } : wt = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wt(e);
}
function Ui(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mr(e, t) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function Fi(e, t, r) {
  return t && mr(e.prototype, t), r && mr(e, r), e;
}
function gr(e) {
  return qi(e) || Yi(e) || Xi(e) || Ki();
}
function qi(e) {
  if (Array.isArray(e))
    return Wt(e);
}
function Yi(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Xi(e, t) {
  if (e) {
    if (typeof e == "string")
      return Wt(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Wt(e, t);
  }
}
function Wt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, i = new Array(t); r < t; r++)
    i[r] = e[r];
  return i;
}
function Ki() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gi(e) {
  var t;
  return typeof e == "function" ? t = {
    callback: e
  } : t = e, t;
}
function Ji(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, n, a, c = function(l) {
    for (var p = arguments.length, f = new Array(p > 1 ? p - 1 : 0), _ = 1; _ < p; _++)
      f[_ - 1] = arguments[_];
    if (a = f, !(i && l === n)) {
      var S = r.leading;
      typeof S == "function" && (S = S(l, n)), (!i || l !== n) && S && e.apply(void 0, [l].concat(gr(a))), n = l, clearTimeout(i), i = setTimeout(function() {
        e.apply(void 0, [l].concat(gr(a))), i = 0;
      }, t);
    }
  };
  return c._clear = function() {
    clearTimeout(i), i = null;
  }, c;
}
function Hr(e, t) {
  if (e === t)
    return !0;
  if (wt(e) === "object") {
    for (var r in e)
      if (!Hr(e[r], t[r]))
        return !1;
    return !0;
  }
  return !1;
}
var Qi = /* @__PURE__ */ function() {
  function e(t, r, i) {
    Ui(this, e), this.el = t, this.observer = null, this.frozen = !1, this.createObserver(r, i);
  }
  return Fi(e, [{
    key: "createObserver",
    value: function(r, i) {
      var n = this;
      if (this.observer && this.destroyObserver(), !this.frozen) {
        if (this.options = Gi(r), this.callback = function(s, l) {
          n.options.callback(s, l), s && n.options.once && (n.frozen = !0, n.destroyObserver());
        }, this.callback && this.options.throttle) {
          var a = this.options.throttleOptions || {}, c = a.leading;
          this.callback = Ji(this.callback, this.options.throttle, {
            leading: function(l) {
              return c === "both" || c === "visible" && l || c === "hidden" && !l;
            }
          });
        }
        this.oldResult = void 0, this.observer = new IntersectionObserver(function(s) {
          var l = s[0];
          if (s.length > 1) {
            var p = s.find(function(_) {
              return _.isIntersecting;
            });
            p && (l = p);
          }
          if (n.callback) {
            var f = l.isIntersecting && l.intersectionRatio >= n.threshold;
            if (f === n.oldResult)
              return;
            n.oldResult = f, n.callback(f, l);
          }
        }, this.options.intersection), Jt(function() {
          n.observer && n.observer.observe(n.el);
        });
      }
    }
  }, {
    key: "destroyObserver",
    value: function() {
      this.observer && (this.observer.disconnect(), this.observer = null), this.callback && this.callback._clear && (this.callback._clear(), this.callback = null);
    }
  }, {
    key: "threshold",
    get: function() {
      return this.options.intersection && typeof this.options.intersection.threshold == "number" ? this.options.intersection.threshold : 0;
    }
  }]), e;
}();
function Wr(e, t, r) {
  var i = t.value;
  if (i)
    if (typeof IntersectionObserver > "u")
      console.warn("[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill");
    else {
      var n = new Qi(e, i, r);
      e._vue_visibilityState = n;
    }
}
function Zi(e, t, r) {
  var i = t.value, n = t.oldValue;
  if (!Hr(i, n)) {
    var a = e._vue_visibilityState;
    if (!i) {
      Ur(e);
      return;
    }
    a ? a.createObserver(i, r) : Wr(e, {
      value: i
    }, r);
  }
}
function Ur(e) {
  var t = e._vue_visibilityState;
  t && (t.destroyObserver(), delete e._vue_visibilityState);
}
var en = {
  beforeMount: Wr,
  updated: Zi,
  unmounted: Ur
}, tn = {
  itemsLimit: 1e3
}, rn = /(auto|scroll)/;
function Fr(e, t) {
  return e.parentNode === null ? t : Fr(e.parentNode, t.concat([e]));
}
var Pt = function(t, r) {
  return getComputedStyle(t, null).getPropertyValue(r);
}, nn = function(t) {
  return Pt(t, "overflow") + Pt(t, "overflow-y") + Pt(t, "overflow-x");
}, on = function(t) {
  return rn.test(nn(t));
};
function yr(e) {
  if (e instanceof HTMLElement || e instanceof SVGElement) {
    for (var t = Fr(e.parentNode, []), r = 0; r < t.length; r += 1)
      if (on(t[r]))
        return t[r];
    return document.scrollingElement || document.documentElement;
  }
}
function Ut(e) {
  "@babel/helpers - typeof";
  return Ut = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ut(e);
}
var an = {
  items: {
    type: Array,
    required: !0
  },
  keyField: {
    type: String,
    default: "id"
  },
  direction: {
    type: String,
    default: "vertical",
    validator: function(t) {
      return ["vertical", "horizontal"].includes(t);
    }
  },
  listTag: {
    type: String,
    default: "div"
  },
  itemTag: {
    type: String,
    default: "div"
  }
};
function sn() {
  return this.items.length && Ut(this.items[0]) !== "object";
}
var Ft = !1;
if (typeof window < "u") {
  Ft = !1;
  try {
    var ln = Object.defineProperty({}, "passive", {
      get: function() {
        Ft = !0;
      }
    });
    window.addEventListener("test", null, ln);
  } catch {
  }
}
let cn = 0;
var Zt = {
  name: "RecycleScroller",
  components: {
    ResizeObserver: Lt
  },
  directives: {
    ObserveVisibility: en
  },
  props: {
    ...an,
    itemSize: {
      type: Number,
      default: null
    },
    gridItems: {
      type: Number,
      default: void 0
    },
    itemSecondarySize: {
      type: Number,
      default: void 0
    },
    minItemSize: {
      type: [Number, String],
      default: null
    },
    sizeField: {
      type: String,
      default: "size"
    },
    typeField: {
      type: String,
      default: "type"
    },
    buffer: {
      type: Number,
      default: 200
    },
    pageMode: {
      type: Boolean,
      default: !1
    },
    prerender: {
      type: Number,
      default: 0
    },
    emitUpdate: {
      type: Boolean,
      default: !1
    },
    updateInterval: {
      type: Number,
      default: 0
    },
    skipHover: {
      type: Boolean,
      default: !1
    },
    listTag: {
      type: String,
      default: "div"
    },
    itemTag: {
      type: String,
      default: "div"
    },
    listClass: {
      type: [String, Object, Array],
      default: ""
    },
    itemClass: {
      type: [String, Object, Array],
      default: ""
    }
  },
  emits: [
    "resize",
    "visible",
    "hidden",
    "update",
    "scroll-start",
    "scroll-end"
  ],
  data() {
    return {
      pool: [],
      totalSize: 0,
      ready: !1,
      hoverKey: null
    };
  },
  computed: {
    sizes() {
      if (this.itemSize === null) {
        const e = {
          "-1": { accumulator: 0 }
        }, t = this.items, r = this.sizeField, i = this.minItemSize;
        let n = 1e4, a = 0, c;
        for (let s = 0, l = t.length; s < l; s++)
          c = t[s][r] || i, c < n && (n = c), a += c, e[s] = { accumulator: a, size: c };
        return this.$_computedMinItemSize = n, e;
      }
      return [];
    },
    simpleArray: sn,
    itemIndexByKey() {
      const { keyField: e, items: t } = this, r = {};
      for (let i = 0, n = t.length; i < n; i++)
        r[t[i][e]] = i;
      return r;
    }
  },
  watch: {
    items() {
      this.updateVisibleItems(!0);
    },
    pageMode() {
      this.applyPageMode(), this.updateVisibleItems(!1);
    },
    sizes: {
      handler() {
        this.updateVisibleItems(!1);
      },
      deep: !0
    },
    gridItems() {
      this.updateVisibleItems(!0);
    },
    itemSecondarySize() {
      this.updateVisibleItems(!0);
    }
  },
  created() {
    this.$_startIndex = 0, this.$_endIndex = 0, this.$_views = /* @__PURE__ */ new Map(), this.$_unusedViews = /* @__PURE__ */ new Map(), this.$_scrollDirty = !1, this.$_lastUpdateScrollPosition = 0, this.prerender && (this.$_prerender = !0, this.updateVisibleItems(!1)), this.gridItems && !this.itemSize && console.error("[vue-recycle-scroller] You must provide an itemSize when using gridItems");
  },
  mounted() {
    this.applyPageMode(), this.$nextTick(() => {
      this.$_prerender = !1, this.updateVisibleItems(!0), this.ready = !0;
    });
  },
  activated() {
    const e = this.$_lastUpdateScrollPosition;
    typeof e == "number" && this.$nextTick(() => {
      this.scrollToPosition(e);
    });
  },
  beforeUnmount() {
    this.removeListeners();
  },
  methods: {
    addView(e, t, r, i, n) {
      const a = Ei({
        id: cn++,
        index: t,
        used: !0,
        key: i,
        type: n
      }), c = Ai({
        item: r,
        position: 0,
        nr: a
      });
      return e.push(c), c;
    },
    unuseView(e, t = !1) {
      const r = this.$_unusedViews, i = e.nr.type;
      let n = r.get(i);
      n || (n = [], r.set(i, n)), n.push(e), t || (e.nr.used = !1, e.position = -9999);
    },
    handleResize() {
      this.$emit("resize"), this.ready && this.updateVisibleItems(!1);
    },
    handleScroll(e) {
      if (!this.$_scrollDirty) {
        if (this.$_scrollDirty = !0, this.$_updateTimeout)
          return;
        const t = () => requestAnimationFrame(() => {
          this.$_scrollDirty = !1;
          const { continuous: r } = this.updateVisibleItems(!1, !0);
          r || (clearTimeout(this.$_refreshTimout), this.$_refreshTimout = setTimeout(this.handleScroll, this.updateInterval + 100));
        });
        t(), this.updateInterval && (this.$_updateTimeout = setTimeout(() => {
          this.$_updateTimeout = 0, this.$_scrollDirty && t();
        }, this.updateInterval));
      }
    },
    handleVisibilityChange(e, t) {
      this.ready && (e || t.boundingClientRect.width !== 0 || t.boundingClientRect.height !== 0 ? (this.$emit("visible"), requestAnimationFrame(() => {
        this.updateVisibleItems(!1);
      })) : this.$emit("hidden"));
    },
    updateVisibleItems(e, t = !1) {
      const r = this.itemSize, i = this.gridItems || 1, n = this.itemSecondarySize || r, a = this.$_computedMinItemSize, c = this.typeField, s = this.simpleArray ? null : this.keyField, l = this.items, p = l.length, f = this.sizes, _ = this.$_views, S = this.$_unusedViews, g = this.pool, v = this.itemIndexByKey;
      let h, u, m, w, x;
      if (!p)
        h = u = w = x = m = 0;
      else if (this.$_prerender)
        h = w = 0, u = x = Math.min(this.prerender, l.length), m = null;
      else {
        const O = this.getScroll();
        if (t) {
          let E = O.start - this.$_lastUpdateScrollPosition;
          if (E < 0 && (E = -E), r === null && E < a || E < r)
            return {
              continuous: !0
            };
        }
        this.$_lastUpdateScrollPosition = O.start;
        const k = this.buffer;
        O.start -= k, O.end += k;
        let A = 0;
        if (this.$refs.before && (A = this.$refs.before.scrollHeight, O.start -= A), this.$refs.after) {
          const E = this.$refs.after.scrollHeight;
          O.end += E;
        }
        if (r === null) {
          let E, P = 0, N = p - 1, L = ~~(p / 2), j;
          do
            j = L, E = f[L].accumulator, E < O.start ? P = L : L < p - 1 && f[L + 1].accumulator > O.start && (N = L), L = ~~((P + N) / 2);
          while (L !== j);
          for (L < 0 && (L = 0), h = L, m = f[p - 1].accumulator, u = L; u < p && f[u].accumulator < O.end; u++)
            ;
          for (u === -1 ? u = l.length - 1 : (u++, u > p && (u = p)), w = h; w < p && A + f[w].accumulator < O.start; w++)
            ;
          for (x = w; x < p && A + f[x].accumulator < O.end; x++)
            ;
        } else {
          h = ~~(O.start / r * i);
          const E = h % i;
          h -= E, u = Math.ceil(O.end / r * i), w = Math.max(0, Math.floor((O.start - A) / r * i)), x = Math.floor((O.end - A) / r * i), h < 0 && (h = 0), u > p && (u = p), w < 0 && (w = 0), x > p && (x = p), m = Math.ceil(p / i) * r;
        }
      }
      u - h > tn.itemsLimit && this.itemsLimitError(), this.totalSize = m;
      let o;
      const C = h <= this.$_endIndex && u >= this.$_startIndex;
      if (C)
        for (let O = 0, k = g.length; O < k; O++)
          o = g[O], o.nr.used && (e && (o.nr.index = v[o.item[s]]), (o.nr.index == null || o.nr.index < h || o.nr.index >= u) && this.unuseView(o));
      const y = C ? null : /* @__PURE__ */ new Map();
      let $, M, V;
      for (let O = h; O < u; O++) {
        $ = l[O];
        const k = s ? $[s] : $;
        if (k == null)
          throw new Error(`Key is ${k} on item (keyField is '${s}')`);
        if (o = _.get(k), !r && !f[O].size) {
          o && this.unuseView(o);
          continue;
        }
        M = $[c];
        let A = S.get(M), E = !1;
        if (!o)
          C ? A && A.length ? o = A.pop() : o = this.addView(g, O, $, k, M) : (V = y.get(M) || 0, (!A || V >= A.length) && (o = this.addView(g, O, $, k, M), this.unuseView(o, !0), A = S.get(M)), o = A[V], y.set(M, V + 1)), _.delete(o.nr.key), o.nr.used = !0, o.nr.index = O, o.nr.key = k, o.nr.type = M, _.set(k, o), E = !0;
        else if (!o.nr.used && (o.nr.used = !0, E = !0, A)) {
          const P = A.indexOf(o);
          P !== -1 && A.splice(P, 1);
        }
        o.item = $, E && (O === l.length - 1 && this.$emit("scroll-end"), O === 0 && this.$emit("scroll-start")), r === null ? (o.position = f[O - 1].accumulator, o.offset = 0) : (o.position = Math.floor(O / i) * r, o.offset = O % i * n);
      }
      return this.$_startIndex = h, this.$_endIndex = u, this.emitUpdate && this.$emit("update", h, u, w, x), clearTimeout(this.$_sortTimer), this.$_sortTimer = setTimeout(this.sortViews, this.updateInterval + 300), {
        continuous: C
      };
    },
    getListenerTarget() {
      let e = yr(this.$el);
      return window.document && (e === window.document.documentElement || e === window.document.body) && (e = window), e;
    },
    getScroll() {
      const { $el: e, direction: t } = this, r = t === "vertical";
      let i;
      if (this.pageMode) {
        const n = e.getBoundingClientRect(), a = r ? n.height : n.width;
        let c = -(r ? n.top : n.left), s = r ? window.innerHeight : window.innerWidth;
        c < 0 && (s += c, c = 0), c + s > a && (s = a - c), i = {
          start: c,
          end: c + s
        };
      } else
        r ? i = {
          start: e.scrollTop,
          end: e.scrollTop + e.clientHeight
        } : i = {
          start: e.scrollLeft,
          end: e.scrollLeft + e.clientWidth
        };
      return i;
    },
    applyPageMode() {
      this.pageMode ? this.addListeners() : this.removeListeners();
    },
    addListeners() {
      this.listenerTarget = this.getListenerTarget(), this.listenerTarget.addEventListener("scroll", this.handleScroll, Ft ? {
        passive: !0
      } : !1), this.listenerTarget.addEventListener("resize", this.handleResize);
    },
    removeListeners() {
      this.listenerTarget && (this.listenerTarget.removeEventListener("scroll", this.handleScroll), this.listenerTarget.removeEventListener("resize", this.handleResize), this.listenerTarget = null);
    },
    scrollToItem(e) {
      let t;
      const r = this.gridItems || 1;
      this.itemSize === null ? t = e > 0 ? this.sizes[e - 1].accumulator : 0 : t = Math.floor(e / r) * this.itemSize, this.scrollToPosition(t);
    },
    scrollToPosition(e) {
      const t = this.direction === "vertical" ? { scroll: "scrollTop", start: "top" } : { scroll: "scrollLeft", start: "left" };
      let r, i, n;
      if (this.pageMode) {
        const a = yr(this.$el), c = a.tagName === "HTML" ? 0 : a[t.scroll], s = a.getBoundingClientRect(), p = this.$el.getBoundingClientRect()[t.start] - s[t.start];
        r = a, i = t.scroll, n = e + c + p;
      } else
        r = this.$el, i = t.scroll, n = e;
      r[i] = n;
    },
    itemsLimitError() {
      throw setTimeout(() => {
        console.log("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", this.$el), console.log("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
      }), new Error("Rendered items limit reached");
    },
    sortViews() {
      this.pool.sort((e, t) => e.nr.index - t.nr.index);
    }
  }
};
const un = {
  key: 0,
  ref: "before",
  class: "vue-recycle-scroller__slot"
}, fn = {
  key: 1,
  ref: "after",
  class: "vue-recycle-scroller__slot"
};
function dn(e, t, r, i, n, a) {
  const c = Ci("ResizeObserver"), s = $i("observe-visibility");
  return ki((z(), F(
    "div",
    {
      class: Qe(["vue-recycle-scroller", {
        ready: n.ready,
        "page-mode": r.pageMode,
        [`direction-${e.direction}`]: !0
      }]),
      onScrollPassive: t[0] || (t[0] = (...l) => a.handleScroll && a.handleScroll(...l))
    },
    [
      e.$slots.before ? (z(), F(
        "div",
        un,
        [
          Te(e.$slots, "before")
        ],
        512
        /* NEED_PATCH */
      )) : ze("v-if", !0),
      (z(), Ve(vr(r.listTag), {
        ref: "wrapper",
        style: Ot({ [e.direction === "vertical" ? "minHeight" : "minWidth"]: n.totalSize + "px" }),
        class: Qe(["vue-recycle-scroller__item-wrapper", r.listClass])
      }, {
        default: St(() => [
          (z(!0), F(
            Br,
            null,
            Nr(n.pool, (l) => (z(), Ve(vr(r.itemTag), Di({
              key: l.nr.id,
              style: n.ready ? {
                transform: `translate${e.direction === "vertical" ? "Y" : "X"}(${l.position}px) translate${e.direction === "vertical" ? "X" : "Y"}(${l.offset}px)`,
                width: r.gridItems ? `${e.direction === "vertical" && r.itemSecondarySize || r.itemSize}px` : void 0,
                height: r.gridItems ? `${e.direction === "horizontal" && r.itemSecondarySize || r.itemSize}px` : void 0
              } : null,
              class: ["vue-recycle-scroller__item-view", [
                r.itemClass,
                {
                  hover: !r.skipHover && n.hoverKey === l.nr.key
                }
              ]]
            }, Li(r.skipHover ? {} : {
              mouseenter: () => {
                n.hoverKey = l.nr.key;
              },
              mouseleave: () => {
                n.hoverKey = null;
              }
            })), {
              default: St(() => [
                Te(e.$slots, "default", {
                  item: l.item,
                  index: l.nr.index,
                  active: l.nr.used
                })
              ]),
              _: 2
              /* DYNAMIC */
            }, 1040, ["style", "class"]))),
            128
            /* KEYED_FRAGMENT */
          )),
          Te(e.$slots, "empty")
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["style", "class"])),
      e.$slots.after ? (z(), F(
        "div",
        fn,
        [
          Te(e.$slots, "after")
        ],
        512
        /* NEED_PATCH */
      )) : ze("v-if", !0),
      xt(c, { onNotify: a.handleResize }, null, 8, ["onNotify"])
    ],
    34
    /* CLASS, HYDRATE_EVENTS */
  )), [
    [s, a.handleVisibilityChange]
  ]);
}
Zt.render = dn;
Zt.__file = "src/components/RecycleScroller.vue";
var Xe = /* @__PURE__ */ ((e) => (e.single = "single", e.multiple = "multiple", e))(Xe || {}), ae = /* @__PURE__ */ ((e) => (e.active = "active", e.inactive = "inactive", e))(ae || {}), te = /* @__PURE__ */ ((e) => (e[e.en = 1] = "en", e[e.cn = 2] = "cn", e[e.jp = 3] = "jp", e[e.kr = 4] = "kr", e[e.other = 5] = "other", e[e.history = 6] = "history", e))(te || {}), qt = /* @__PURE__ */ ((e) => (e.cn = "cn", e.en = "en", e.jp = "jp", e.tw = "tw", e))(qt || {});
const br = {
  [te.en]: "en_name",
  [te.cn]: "cn_name",
  [te.jp]: "jp_name",
  [te.kr]: "kr_name",
  [te.other]: "other_name",
  [te.history]: "company_history_names"
}, pn = {
  cn: ["cn_name", "en_name", "jp_name", "kr_name", "other_name"],
  tw: ["cn_name", "en_name", "jp_name", "kr_name", "other_name"],
  en: ["en_name", "jp_name", "kr_name", "other_name", "cn_name"],
  jp: ["en_name", "jp_name", "kr_name", "other_name", "cn_name"]
}, wr = "①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳⓪❶❷❸❹❺❻❼❽❾❿⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴㊀㊁㊂㊃㊄㊅㊆㊇㊈㊉ⒶⒷⒸⒹⒺⒻⒼⒽⒾⒿⓀⓁⓂⓃⓄⓅⓆⓇⓈⓉⓊⓋⓌⓍⓎⓏⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ";
function qr(e) {
  const t = H(() => e.opts), r = H(() => {
    let n = B.get(t.value, "highlight.keys", []);
    return n = n.map((a) => a === "." ? "\\." : a), n.sort((a, c) => c.length - a.length), n;
  });
  function i(n) {
    if (!n)
      return "";
    if (B.isEmpty(r.value))
      return n;
    const a = [];
    let c = 0, s = n;
    return r.value.forEach((l) => {
      const p = new RegExp(l, "gmi"), f = p.exec(n);
      f && f.length && (a.push(`<span class="common-corporate-tree__highlight-label">${f[0]}</span>`), c += 1), s = n.replace(p, wr.charAt(c - 1));
    }), a.forEach((l, p) => {
      const f = new RegExp(wr.charAt(p), "gmi");
      s = n.replace(f, a[p]);
    }), s;
  }
  return {
    highlightKeys: r,
    setHighlightLabel: i
  };
}
const er = {
  corpTreeBiz: {
    checkAll: "全选",
    otherName: "曾用名或其他名称：",
    visitTheOfficialWebsite: "访问官网",
    investPercentage: "投资比例",
    otherAnsTips: "该名称暂不支持独立勾选，搜索其母公司时，该名称会被包含在内"
  }
}, tr = {
  corpTreeBiz: {
    checkAll: "All",
    otherName: "Previous name or other name:",
    visitTheOfficialWebsite: "Visit the official website",
    investPercentage: "Parent company investment percentage",
    otherAnsTips: "You cannot select this company name individually. However, it will be included in your search if you select the parent company."
  }
}, rr = {
  corpTreeBiz: {
    checkAll: "全て選択",
    otherName: "旧名または別名：",
    visitTheOfficialWebsite: "公式ウェブサイトをご覧ください",
    investPercentage: "投資比率",
    otherAnsTips: "該名称の単独検索はサポートされていません。親会社の検索時に含まれてヒットされます。"
  }
}, ir = {
  corpTreeBiz: {
    checkAll: "全選",
    otherName: "曾用名或其他名稱：",
    visitTheOfficialWebsite: "訪問官網",
    investPercentage: "投資比例",
    otherAnsTips: "該名稱暫不支持獨立勾選，搜索其母公司時，該名稱會被包含在內"
  }
}, vn = { class: "common-corporate-tree-child__check flex items-center" }, hn = ["checked", "disabled"], mn = ["title"], gn = ["data-id", "innerHTML"], yn = ["title"], bn = ["href", "title"], wn = /* @__PURE__ */ Dt({
  __name: "CorpTreeChild",
  props: {
    dataset: {},
    opts: {},
    service: {}
  },
  emits: ["item-expand", "item-select", "trigger-match"],
  setup(e, { emit: t }) {
    const r = e, { t: i } = Qt({
      messages: {
        cn: er,
        en: tr,
        tw: ir,
        jp: rr
      }
    }), n = H(() => r.dataset.is_expanded ? ji : Pi), { setHighlightLabel: a } = qr(r.service), c = H(() => ({ "padding-left": `${15 * r.dataset.deepIndex + 4}px` })), s = H(() => ({ "max-width": `calc(100% - ${((r.dataset.invest_percent || 0) > 0 ? 106 : 40) + 40}px)` })), l = H(() => r.dataset.patent_label !== ae.inactive && !r.dataset.is_other_ans), p = H(() => r.dataset.is_inactive), f = H(() => {
      const u = r.opts.label;
      let m = u ? r.dataset[u.toString()] || "" : r.dataset.label || "";
      return r.dataset.isHighLight && (m = a(m)), r.dataset.hit_name_tag === te.history && (m = `<span class="common-corporate-tree__highlight-label">${m}</span>`), m;
    });
    async function _() {
      const u = r.opts.label, m = u ? r.dataset[u.toString()] || "" : r.dataset.label || "";
      if (r.opts.focusVal && m === r.opts.focusVal) {
        await Jt();
        const w = Ii(), x = w == null ? void 0 : w.proxy;
        t("trigger-match", x);
      }
    }
    function S(u) {
      t("item-expand", u);
    }
    function g(u) {
      t("item-select", u);
    }
    function v(u) {
      !l.value || !r.service.clickLabelSelect || g(u);
    }
    function h(u) {
      const m = ((u || 0) * 100).toFixed(1), w = m.split(".");
      return `${w[1] === "0" ? w[0] : m}%`;
    }
    return Tt(() => r.opts, () => {
      _();
    }), (u, m) => (z(), F("div", {
      class: Qe(["common-corporate-tree-child", {
        "common-corporate-tree-child--invest": u.dataset.invest_percent,
        "common-corporate-tree-child--selected": u.dataset.isSelected,
        "common-corporate-tree-child--can-click": u.service.clickLabelSelect
      }])
    }, [
      X("div", {
        style: Ot(c.value),
        class: "common-corporate-tree-child__label flex items-center",
        onClick: m[2] || (m[2] = zt((w) => v(u.dataset), ["stop"]))
      }, [
        X("span", vn, [
          X("input", {
            type: "checkbox",
            checked: u.dataset.isSelected,
            disabled: !l.value,
            class: "th-checkbox",
            onChange: m[0] || (m[0] = (w) => g(u.dataset))
          }, null, 40, hn),
          u.dataset.is_other_ans ? (z(), F("span", {
            key: 0,
            class: "toolTip__label",
            title: ye(i)("corpTreeBiz.otherAnsTips")
          }, null, 8, mn)) : ze("", !0)
        ]),
        X("span", {
          class: "common-corporate-tree-child__icon",
          onClick: m[1] || (m[1] = zt((w) => S(u.dataset), ["stop"]))
        }, [
          u.dataset.hasChildren ? (z(), Ve(ye(hr), {
            key: 0,
            icon: n.value,
            class: "search-icon"
          }, null, 8, ["icon"])) : (z(), Ve(ye(hr), {
            key: 1,
            class: "common-corporate-tree-child__icon-nodata",
            icon: ye(Ri)
          }, null, 8, ["icon"]))
        ]),
        X("span", {
          style: Ot(s.value),
          class: Qe(["common-corporate-tree-child__name", { "common-corporate-tree-child__name--disabled": p.value }]),
          "data-id": u.dataset.id,
          innerHTML: f.value
        }, null, 14, gn),
        X("span", {
          class: "common-corporate-tree-child__invest-icon",
          title: ye(i)("corpTreeBiz.investPercentage")
        }, Et(h(u.dataset.invest_percent)), 9, yn),
        u.dataset.website ? (z(), F("a", {
          key: 0,
          href: u.dataset.website,
          title: ye(i)("corpTreeBiz.visitTheOfficialWebsite"),
          target: "_blank",
          class: "common-corporate-tree-child__link"
        }, null, 8, bn)) : ze("", !0)
      ], 4),
      X("div", {
        class: "common-corporate-tree-child__tail",
        onClick: m[3] || (m[3] = zt((w) => v(u.dataset), ["stop"]))
      }, [
        Te(u.$slots, "tail", { dataset: u.dataset })
      ])
    ], 2));
  }
});
var q = "top", Q = "bottom", Z = "right", Y = "left", nr = "auto", it = [q, Q, Z, Y], Pe = "start", Ze = "end", _n = "clippingParents", Yr = "viewport", Ye = "popper", On = "reference", _r = /* @__PURE__ */ it.reduce(function(e, t) {
  return e.concat([t + "-" + Pe, t + "-" + Ze]);
}, []), Xr = /* @__PURE__ */ [].concat(it, [nr]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Pe, t + "-" + Ze]);
}, []), Sn = "beforeRead", xn = "read", Tn = "afterRead", En = "beforeMain", An = "main", Cn = "afterMain", $n = "beforeWrite", kn = "write", Dn = "afterWrite", Ln = [Sn, xn, Tn, En, An, Cn, $n, kn, Dn];
function le(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function K(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ae(e) {
  var t = K(e).Element;
  return e instanceof t || e instanceof Element;
}
function J(e) {
  var t = K(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function or(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = K(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function In(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var i = t.styles[r] || {}, n = t.attributes[r] || {}, a = t.elements[r];
    !J(a) || !le(a) || (Object.assign(a.style, i), Object.keys(n).forEach(function(c) {
      var s = n[c];
      s === !1 ? a.removeAttribute(c) : a.setAttribute(c, s === !0 ? "" : s);
    }));
  });
}
function Mn(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var n = t.elements[i], a = t.attributes[i] || {}, c = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : r[i]), s = c.reduce(function(l, p) {
        return l[p] = "", l;
      }, {});
      !J(n) || !le(n) || (Object.assign(n.style, s), Object.keys(a).forEach(function(l) {
        n.removeAttribute(l);
      }));
    });
  };
}
const Kr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: In,
  effect: Mn,
  requires: ["computeStyles"]
};
function se(e) {
  return e.split("-")[0];
}
var Ee = Math.max, At = Math.min, je = Math.round;
function Yt() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Gr() {
  return !/^((?!chrome|android).)*safari/i.test(Yt());
}
function Re(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var i = e.getBoundingClientRect(), n = 1, a = 1;
  t && J(e) && (n = e.offsetWidth > 0 && je(i.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && je(i.height) / e.offsetHeight || 1);
  var c = Ae(e) ? K(e) : window, s = c.visualViewport, l = !Gr() && r, p = (i.left + (l && s ? s.offsetLeft : 0)) / n, f = (i.top + (l && s ? s.offsetTop : 0)) / a, _ = i.width / n, S = i.height / a;
  return {
    width: _,
    height: S,
    top: f,
    right: p + _,
    bottom: f + S,
    left: p,
    x: p,
    y: f
  };
}
function ar(e) {
  var t = Re(e), r = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: i
  };
}
function Jr(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && or(r)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function ve(e) {
  return K(e).getComputedStyle(e);
}
function Vn(e) {
  return ["table", "td", "th"].indexOf(le(e)) >= 0;
}
function we(e) {
  return ((Ae(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function It(e) {
  return le(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (or(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    we(e)
  );
}
function Or(e) {
  return !J(e) || // https://github.com/popperjs/popper-core/issues/837
  ve(e).position === "fixed" ? null : e.offsetParent;
}
function zn(e) {
  var t = /firefox/i.test(Yt()), r = /Trident/i.test(Yt());
  if (r && J(e)) {
    var i = ve(e);
    if (i.position === "fixed")
      return null;
  }
  var n = It(e);
  for (or(n) && (n = n.host); J(n) && ["html", "body"].indexOf(le(n)) < 0; ) {
    var a = ve(n);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function nt(e) {
  for (var t = K(e), r = Or(e); r && Vn(r) && ve(r).position === "static"; )
    r = Or(r);
  return r && (le(r) === "html" || le(r) === "body" && ve(r).position === "static") ? t : r || zn(e) || t;
}
function sr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ke(e, t, r) {
  return Ee(e, At(t, r));
}
function Pn(e, t, r) {
  var i = Ke(e, t, r);
  return i > r ? r : i;
}
function Qr() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Zr(e) {
  return Object.assign({}, Qr(), e);
}
function ei(e, t) {
  return t.reduce(function(r, i) {
    return r[i] = e, r;
  }, {});
}
var jn = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Zr(typeof t != "number" ? t : ei(t, it));
};
function Rn(e) {
  var t, r = e.state, i = e.name, n = e.options, a = r.elements.arrow, c = r.modifiersData.popperOffsets, s = se(r.placement), l = sr(s), p = [Y, Z].indexOf(s) >= 0, f = p ? "height" : "width";
  if (!(!a || !c)) {
    var _ = jn(n.padding, r), S = ar(a), g = l === "y" ? q : Y, v = l === "y" ? Q : Z, h = r.rects.reference[f] + r.rects.reference[l] - c[l] - r.rects.popper[f], u = c[l] - r.rects.reference[l], m = nt(a), w = m ? l === "y" ? m.clientHeight || 0 : m.clientWidth || 0 : 0, x = h / 2 - u / 2, o = _[g], C = w - S[f] - _[v], y = w / 2 - S[f] / 2 + x, $ = Ke(o, y, C), M = l;
    r.modifiersData[i] = (t = {}, t[M] = $, t.centerOffset = $ - y, t);
  }
}
function Bn(e) {
  var t = e.state, r = e.options, i = r.element, n = i === void 0 ? "[data-popper-arrow]" : i;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || Jr(t.elements.popper, n) && (t.elements.arrow = n));
}
const Nn = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Rn,
  effect: Bn,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Be(e) {
  return e.split("-")[1];
}
var Hn = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Wn(e, t) {
  var r = e.x, i = e.y, n = t.devicePixelRatio || 1;
  return {
    x: je(r * n) / n || 0,
    y: je(i * n) / n || 0
  };
}
function Sr(e) {
  var t, r = e.popper, i = e.popperRect, n = e.placement, a = e.variation, c = e.offsets, s = e.position, l = e.gpuAcceleration, p = e.adaptive, f = e.roundOffsets, _ = e.isFixed, S = c.x, g = S === void 0 ? 0 : S, v = c.y, h = v === void 0 ? 0 : v, u = typeof f == "function" ? f({
    x: g,
    y: h
  }) : {
    x: g,
    y: h
  };
  g = u.x, h = u.y;
  var m = c.hasOwnProperty("x"), w = c.hasOwnProperty("y"), x = Y, o = q, C = window;
  if (p) {
    var y = nt(r), $ = "clientHeight", M = "clientWidth";
    if (y === K(r) && (y = we(r), ve(y).position !== "static" && s === "absolute" && ($ = "scrollHeight", M = "scrollWidth")), y = y, n === q || (n === Y || n === Z) && a === Ze) {
      o = Q;
      var V = _ && y === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[$]
      );
      h -= V - i.height, h *= l ? 1 : -1;
    }
    if (n === Y || (n === q || n === Q) && a === Ze) {
      x = Z;
      var O = _ && y === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[M]
      );
      g -= O - i.width, g *= l ? 1 : -1;
    }
  }
  var k = Object.assign({
    position: s
  }, p && Hn), A = f === !0 ? Wn({
    x: g,
    y: h
  }, K(r)) : {
    x: g,
    y: h
  };
  if (g = A.x, h = A.y, l) {
    var E;
    return Object.assign({}, k, (E = {}, E[o] = w ? "0" : "", E[x] = m ? "0" : "", E.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + h + "px)" : "translate3d(" + g + "px, " + h + "px, 0)", E));
  }
  return Object.assign({}, k, (t = {}, t[o] = w ? h + "px" : "", t[x] = m ? g + "px" : "", t.transform = "", t));
}
function Un(e) {
  var t = e.state, r = e.options, i = r.gpuAcceleration, n = i === void 0 ? !0 : i, a = r.adaptive, c = a === void 0 ? !0 : a, s = r.roundOffsets, l = s === void 0 ? !0 : s, p = {
    placement: se(t.placement),
    variation: Be(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Sr(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: c,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Sr(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Fn = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Un,
  data: {}
};
var mt = {
  passive: !0
};
function qn(e) {
  var t = e.state, r = e.instance, i = e.options, n = i.scroll, a = n === void 0 ? !0 : n, c = i.resize, s = c === void 0 ? !0 : c, l = K(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && p.forEach(function(f) {
    f.addEventListener("scroll", r.update, mt);
  }), s && l.addEventListener("resize", r.update, mt), function() {
    a && p.forEach(function(f) {
      f.removeEventListener("scroll", r.update, mt);
    }), s && l.removeEventListener("resize", r.update, mt);
  };
}
const Yn = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: qn,
  data: {}
};
var Xn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function _t(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Xn[t];
  });
}
var Kn = {
  start: "end",
  end: "start"
};
function xr(e) {
  return e.replace(/start|end/g, function(t) {
    return Kn[t];
  });
}
function lr(e) {
  var t = K(e), r = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: i
  };
}
function cr(e) {
  return Re(we(e)).left + lr(e).scrollLeft;
}
function Gn(e, t) {
  var r = K(e), i = we(e), n = r.visualViewport, a = i.clientWidth, c = i.clientHeight, s = 0, l = 0;
  if (n) {
    a = n.width, c = n.height;
    var p = Gr();
    (p || !p && t === "fixed") && (s = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: s + cr(e),
    y: l
  };
}
function Jn(e) {
  var t, r = we(e), i = lr(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, a = Ee(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), c = Ee(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), s = -i.scrollLeft + cr(e), l = -i.scrollTop;
  return ve(n || r).direction === "rtl" && (s += Ee(r.clientWidth, n ? n.clientWidth : 0) - a), {
    width: a,
    height: c,
    x: s,
    y: l
  };
}
function ur(e) {
  var t = ve(e), r = t.overflow, i = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + i);
}
function ti(e) {
  return ["html", "body", "#document"].indexOf(le(e)) >= 0 ? e.ownerDocument.body : J(e) && ur(e) ? e : ti(It(e));
}
function Ge(e, t) {
  var r;
  t === void 0 && (t = []);
  var i = ti(e), n = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = K(i), c = n ? [a].concat(a.visualViewport || [], ur(i) ? i : []) : i, s = t.concat(c);
  return n ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Ge(It(c)))
  );
}
function Xt(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Qn(e, t) {
  var r = Re(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Tr(e, t, r) {
  return t === Yr ? Xt(Gn(e, r)) : Ae(t) ? Qn(t, r) : Xt(Jn(we(e)));
}
function Zn(e) {
  var t = Ge(It(e)), r = ["absolute", "fixed"].indexOf(ve(e).position) >= 0, i = r && J(e) ? nt(e) : e;
  return Ae(i) ? t.filter(function(n) {
    return Ae(n) && Jr(n, i) && le(n) !== "body";
  }) : [];
}
function eo(e, t, r, i) {
  var n = t === "clippingParents" ? Zn(e) : [].concat(t), a = [].concat(n, [r]), c = a[0], s = a.reduce(function(l, p) {
    var f = Tr(e, p, i);
    return l.top = Ee(f.top, l.top), l.right = At(f.right, l.right), l.bottom = At(f.bottom, l.bottom), l.left = Ee(f.left, l.left), l;
  }, Tr(e, c, i));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function ri(e) {
  var t = e.reference, r = e.element, i = e.placement, n = i ? se(i) : null, a = i ? Be(i) : null, c = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (n) {
    case q:
      l = {
        x: c,
        y: t.y - r.height
      };
      break;
    case Q:
      l = {
        x: c,
        y: t.y + t.height
      };
      break;
    case Z:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Y:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var p = n ? sr(n) : null;
  if (p != null) {
    var f = p === "y" ? "height" : "width";
    switch (a) {
      case Pe:
        l[p] = l[p] - (t[f] / 2 - r[f] / 2);
        break;
      case Ze:
        l[p] = l[p] + (t[f] / 2 - r[f] / 2);
        break;
    }
  }
  return l;
}
function et(e, t) {
  t === void 0 && (t = {});
  var r = t, i = r.placement, n = i === void 0 ? e.placement : i, a = r.strategy, c = a === void 0 ? e.strategy : a, s = r.boundary, l = s === void 0 ? _n : s, p = r.rootBoundary, f = p === void 0 ? Yr : p, _ = r.elementContext, S = _ === void 0 ? Ye : _, g = r.altBoundary, v = g === void 0 ? !1 : g, h = r.padding, u = h === void 0 ? 0 : h, m = Zr(typeof u != "number" ? u : ei(u, it)), w = S === Ye ? On : Ye, x = e.rects.popper, o = e.elements[v ? w : S], C = eo(Ae(o) ? o : o.contextElement || we(e.elements.popper), l, f, c), y = Re(e.elements.reference), $ = ri({
    reference: y,
    element: x,
    strategy: "absolute",
    placement: n
  }), M = Xt(Object.assign({}, x, $)), V = S === Ye ? M : y, O = {
    top: C.top - V.top + m.top,
    bottom: V.bottom - C.bottom + m.bottom,
    left: C.left - V.left + m.left,
    right: V.right - C.right + m.right
  }, k = e.modifiersData.offset;
  if (S === Ye && k) {
    var A = k[n];
    Object.keys(O).forEach(function(E) {
      var P = [Z, Q].indexOf(E) >= 0 ? 1 : -1, N = [q, Q].indexOf(E) >= 0 ? "y" : "x";
      O[E] += A[N] * P;
    });
  }
  return O;
}
function to(e, t) {
  t === void 0 && (t = {});
  var r = t, i = r.placement, n = r.boundary, a = r.rootBoundary, c = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, p = l === void 0 ? Xr : l, f = Be(i), _ = f ? s ? _r : _r.filter(function(v) {
    return Be(v) === f;
  }) : it, S = _.filter(function(v) {
    return p.indexOf(v) >= 0;
  });
  S.length === 0 && (S = _);
  var g = S.reduce(function(v, h) {
    return v[h] = et(e, {
      placement: h,
      boundary: n,
      rootBoundary: a,
      padding: c
    })[se(h)], v;
  }, {});
  return Object.keys(g).sort(function(v, h) {
    return g[v] - g[h];
  });
}
function ro(e) {
  if (se(e) === nr)
    return [];
  var t = _t(e);
  return [xr(e), t, xr(t)];
}
function io(e) {
  var t = e.state, r = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var n = r.mainAxis, a = n === void 0 ? !0 : n, c = r.altAxis, s = c === void 0 ? !0 : c, l = r.fallbackPlacements, p = r.padding, f = r.boundary, _ = r.rootBoundary, S = r.altBoundary, g = r.flipVariations, v = g === void 0 ? !0 : g, h = r.allowedAutoPlacements, u = t.options.placement, m = se(u), w = m === u, x = l || (w || !v ? [_t(u)] : ro(u)), o = [u].concat(x).reduce(function(ce, ee) {
      return ce.concat(se(ee) === nr ? to(t, {
        placement: ee,
        boundary: f,
        rootBoundary: _,
        padding: p,
        flipVariations: v,
        allowedAutoPlacements: h
      }) : ee);
    }, []), C = t.rects.reference, y = t.rects.popper, $ = /* @__PURE__ */ new Map(), M = !0, V = o[0], O = 0; O < o.length; O++) {
      var k = o[O], A = se(k), E = Be(k) === Pe, P = [q, Q].indexOf(A) >= 0, N = P ? "width" : "height", L = et(t, {
        placement: k,
        boundary: f,
        rootBoundary: _,
        altBoundary: S,
        padding: p
      }), j = P ? E ? Z : Y : E ? Q : q;
      C[N] > y[N] && (j = _t(j));
      var R = _t(j), re = [];
      if (a && re.push(L[A] <= 0), s && re.push(L[j] <= 0, L[R] <= 0), re.every(function(ce) {
        return ce;
      })) {
        V = k, M = !1;
        break;
      }
      $.set(k, re);
    }
    if (M)
      for (var ie = v ? 3 : 1, _e = function(ee) {
        var ue = o.find(function(Ce) {
          var fe = $.get(Ce);
          if (fe)
            return fe.slice(0, ee).every(function($e) {
              return $e;
            });
        });
        if (ue)
          return V = ue, "break";
      }, ne = ie; ne > 0; ne--) {
        var Oe = _e(ne);
        if (Oe === "break")
          break;
      }
    t.placement !== V && (t.modifiersData[i]._skip = !0, t.placement = V, t.reset = !0);
  }
}
const no = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: io,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Er(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Ar(e) {
  return [q, Z, Q, Y].some(function(t) {
    return e[t] >= 0;
  });
}
function oo(e) {
  var t = e.state, r = e.name, i = t.rects.reference, n = t.rects.popper, a = t.modifiersData.preventOverflow, c = et(t, {
    elementContext: "reference"
  }), s = et(t, {
    altBoundary: !0
  }), l = Er(c, i), p = Er(s, n, a), f = Ar(l), _ = Ar(p);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: p,
    isReferenceHidden: f,
    hasPopperEscaped: _
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": _
  });
}
const ao = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: oo
};
function so(e, t, r) {
  var i = se(e), n = [Y, q].indexOf(i) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, c = a[0], s = a[1];
  return c = c || 0, s = (s || 0) * n, [Y, Z].indexOf(i) >= 0 ? {
    x: s,
    y: c
  } : {
    x: c,
    y: s
  };
}
function lo(e) {
  var t = e.state, r = e.options, i = e.name, n = r.offset, a = n === void 0 ? [0, 0] : n, c = Xr.reduce(function(f, _) {
    return f[_] = so(_, t.rects, a), f;
  }, {}), s = c[t.placement], l = s.x, p = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += p), t.modifiersData[i] = c;
}
const co = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: lo
};
function uo(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ri({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const fo = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: uo,
  data: {}
};
function po(e) {
  return e === "x" ? "y" : "x";
}
function vo(e) {
  var t = e.state, r = e.options, i = e.name, n = r.mainAxis, a = n === void 0 ? !0 : n, c = r.altAxis, s = c === void 0 ? !1 : c, l = r.boundary, p = r.rootBoundary, f = r.altBoundary, _ = r.padding, S = r.tether, g = S === void 0 ? !0 : S, v = r.tetherOffset, h = v === void 0 ? 0 : v, u = et(t, {
    boundary: l,
    rootBoundary: p,
    padding: _,
    altBoundary: f
  }), m = se(t.placement), w = Be(t.placement), x = !w, o = sr(m), C = po(o), y = t.modifiersData.popperOffsets, $ = t.rects.reference, M = t.rects.popper, V = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, O = typeof V == "number" ? {
    mainAxis: V,
    altAxis: V
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, V), k = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, A = {
    x: 0,
    y: 0
  };
  if (y) {
    if (a) {
      var E, P = o === "y" ? q : Y, N = o === "y" ? Q : Z, L = o === "y" ? "height" : "width", j = y[o], R = j + u[P], re = j - u[N], ie = g ? -M[L] / 2 : 0, _e = w === Pe ? $[L] : M[L], ne = w === Pe ? -M[L] : -$[L], Oe = t.elements.arrow, ce = g && Oe ? ar(Oe) : {
        width: 0,
        height: 0
      }, ee = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Qr(), ue = ee[P], Ce = ee[N], fe = Ke(0, $[L], ce[L]), $e = x ? $[L] / 2 - ie - fe - ue - O.mainAxis : _e - fe - ue - O.mainAxis, he = x ? -$[L] / 2 + ie + fe + Ce + O.mainAxis : ne + fe + Ce + O.mainAxis, ke = t.elements.arrow && nt(t.elements.arrow), ot = ke ? o === "y" ? ke.clientTop || 0 : ke.clientLeft || 0 : 0, He = (E = k == null ? void 0 : k[o]) != null ? E : 0, at = j + $e - He - ot, st = j + he - He, We = Ke(g ? At(R, at) : R, j, g ? Ee(re, st) : re);
      y[o] = We, A[o] = We - j;
    }
    if (s) {
      var Ue, lt = o === "x" ? q : Y, ct = o === "x" ? Q : Z, de = y[C], me = C === "y" ? "height" : "width", Fe = de + u[lt], Se = de - u[ct], qe = [q, Y].indexOf(m) !== -1, ut = (Ue = k == null ? void 0 : k[C]) != null ? Ue : 0, ft = qe ? Fe : de - $[me] - M[me] - ut + O.altAxis, dt = qe ? de + $[me] + M[me] - ut - O.altAxis : Se, pt = g && qe ? Pn(ft, de, dt) : Ke(g ? ft : Fe, de, g ? dt : Se);
      y[C] = pt, A[C] = pt - de;
    }
    t.modifiersData[i] = A;
  }
}
const ho = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: vo,
  requiresIfExists: ["offset"]
};
function mo(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function go(e) {
  return e === K(e) || !J(e) ? lr(e) : mo(e);
}
function yo(e) {
  var t = e.getBoundingClientRect(), r = je(t.width) / e.offsetWidth || 1, i = je(t.height) / e.offsetHeight || 1;
  return r !== 1 || i !== 1;
}
function bo(e, t, r) {
  r === void 0 && (r = !1);
  var i = J(t), n = J(t) && yo(t), a = we(t), c = Re(e, n, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !r) && ((le(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ur(a)) && (s = go(t)), J(t) ? (l = Re(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = cr(a))), {
    x: c.left + s.scrollLeft - l.x,
    y: c.top + s.scrollTop - l.y,
    width: c.width,
    height: c.height
  };
}
function wo(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function n(a) {
    r.add(a.name);
    var c = [].concat(a.requires || [], a.requiresIfExists || []);
    c.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && n(l);
      }
    }), i.push(a);
  }
  return e.forEach(function(a) {
    r.has(a.name) || n(a);
  }), i;
}
function _o(e) {
  var t = wo(e);
  return Ln.reduce(function(r, i) {
    return r.concat(t.filter(function(n) {
      return n.phase === i;
    }));
  }, []);
}
function Oo(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function So(e) {
  var t = e.reduce(function(r, i) {
    var n = r[i.name];
    return r[i.name] = n ? Object.assign({}, n, i, {
      options: Object.assign({}, n.options, i.options),
      data: Object.assign({}, n.data, i.data)
    }) : i, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Cr = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function $r() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function xo(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, i = r === void 0 ? [] : r, n = t.defaultOptions, a = n === void 0 ? Cr : n;
  return function(s, l, p) {
    p === void 0 && (p = a);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Cr, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, _ = [], S = !1, g = {
      state: f,
      setOptions: function(m) {
        var w = typeof m == "function" ? m(f.options) : m;
        h(), f.options = Object.assign({}, a, f.options, w), f.scrollParents = {
          reference: Ae(s) ? Ge(s) : s.contextElement ? Ge(s.contextElement) : [],
          popper: Ge(l)
        };
        var x = _o(So([].concat(i, f.options.modifiers)));
        return f.orderedModifiers = x.filter(function(o) {
          return o.enabled;
        }), v(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!S) {
          var m = f.elements, w = m.reference, x = m.popper;
          if ($r(w, x)) {
            f.rects = {
              reference: bo(w, nt(x), f.options.strategy === "fixed"),
              popper: ar(x)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(O) {
              return f.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var o = 0; o < f.orderedModifiers.length; o++) {
              if (f.reset === !0) {
                f.reset = !1, o = -1;
                continue;
              }
              var C = f.orderedModifiers[o], y = C.fn, $ = C.options, M = $ === void 0 ? {} : $, V = C.name;
              typeof y == "function" && (f = y({
                state: f,
                options: M,
                name: V,
                instance: g
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Oo(function() {
        return new Promise(function(u) {
          g.forceUpdate(), u(f);
        });
      }),
      destroy: function() {
        h(), S = !0;
      }
    };
    if (!$r(s, l))
      return g;
    g.setOptions(p).then(function(u) {
      !S && p.onFirstUpdate && p.onFirstUpdate(u);
    });
    function v() {
      f.orderedModifiers.forEach(function(u) {
        var m = u.name, w = u.options, x = w === void 0 ? {} : w, o = u.effect;
        if (typeof o == "function") {
          var C = o({
            state: f,
            name: m,
            instance: g,
            options: x
          }), y = function() {
          };
          _.push(C || y);
        }
      });
    }
    function h() {
      _.forEach(function(u) {
        return u();
      }), _ = [];
    }
    return g;
  };
}
var To = [Yn, fo, Fn, Kr, co, no, ho, Nn, ao], Eo = /* @__PURE__ */ xo({
  defaultModifiers: To
}), Ao = "tippy-box", ii = "tippy-content", Co = "tippy-backdrop", ni = "tippy-arrow", oi = "tippy-svg-arrow", be = {
  passive: !0,
  capture: !0
}, ai = function() {
  return document.body;
};
function $o(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function jt(e, t, r) {
  if (Array.isArray(e)) {
    var i = e[t];
    return i ?? (Array.isArray(r) ? r[t] : r);
  }
  return e;
}
function fr(e, t) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function si(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function kr(e, t) {
  if (t === 0)
    return e;
  var r;
  return function(i) {
    clearTimeout(r), r = setTimeout(function() {
      e(i);
    }, t);
  };
}
function li(e, t) {
  var r = Object.assign({}, e);
  return t.forEach(function(i) {
    delete r[i];
  }), r;
}
function ko(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Me(e) {
  return [].concat(e);
}
function Dr(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Do(e) {
  return e.filter(function(t, r) {
    return e.indexOf(t) === r;
  });
}
function Lo(e) {
  return e.split("-")[0];
}
function Ct(e) {
  return [].slice.call(e);
}
function Lr(e) {
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== void 0 && (t[r] = e[r]), t;
  }, {});
}
function Je() {
  return document.createElement("div");
}
function tt(e) {
  return ["Element", "Fragment"].some(function(t) {
    return fr(e, t);
  });
}
function Io(e) {
  return fr(e, "NodeList");
}
function Mo(e) {
  return fr(e, "MouseEvent");
}
function Vo(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function zo(e) {
  return tt(e) ? [e] : Io(e) ? Ct(e) : Array.isArray(e) ? e : Ct(document.querySelectorAll(e));
}
function Rt(e, t) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = t + "ms");
  });
}
function Ir(e, t) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", t);
  });
}
function Po(e) {
  var t, r = Me(e), i = r[0];
  return !(i == null || (t = i.ownerDocument) == null) && t.body ? i.ownerDocument : document;
}
function jo(e, t) {
  var r = t.clientX, i = t.clientY;
  return e.every(function(n) {
    var a = n.popperRect, c = n.popperState, s = n.props, l = s.interactiveBorder, p = Lo(c.placement), f = c.modifiersData.offset;
    if (!f)
      return !0;
    var _ = p === "bottom" ? f.top.y : 0, S = p === "top" ? f.bottom.y : 0, g = p === "right" ? f.left.x : 0, v = p === "left" ? f.right.x : 0, h = a.top - i + _ > l, u = i - a.bottom - S > l, m = a.left - r + g > l, w = r - a.right - v > l;
    return h || u || m || w;
  });
}
function Bt(e, t, r) {
  var i = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(n) {
    e[i](n, r);
  });
}
function Mr(e, t) {
  for (var r = t; r; ) {
    var i;
    if (e.contains(r))
      return !0;
    r = (i = r.getRootNode == null ? void 0 : r.getRootNode()) == null ? void 0 : i.host;
  }
  return !1;
}
var oe = {
  isTouch: !1
}, Vr = 0;
function Ro() {
  oe.isTouch || (oe.isTouch = !0, window.performance && document.addEventListener("mousemove", ci));
}
function ci() {
  var e = performance.now();
  e - Vr < 20 && (oe.isTouch = !1, document.removeEventListener("mousemove", ci)), Vr = e;
}
function Bo() {
  var e = document.activeElement;
  if (Vo(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function No() {
  document.addEventListener("touchstart", Ro, be), window.addEventListener("blur", Bo);
}
var Ho = typeof window < "u" && typeof document < "u", Wo = Ho ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Ie(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function zr(e) {
  var t = /[ \t]{2,}/g, r = /^[ \t]*/gm;
  return e.replace(t, " ").replace(r, "").trim();
}
function Uo(e) {
  return zr(`
  %ctippy.js

  %c` + zr(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function ui(e) {
  return [
    Uo(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var rt;
process.env.NODE_ENV !== "production" && Fo();
function Fo() {
  rt = /* @__PURE__ */ new Set();
}
function pe(e, t) {
  if (e && !rt.has(t)) {
    var r;
    rt.add(t), (r = console).warn.apply(r, ui(t));
  }
}
function $t(e, t) {
  if (e && !rt.has(t)) {
    var r;
    rt.add(t), (r = console).error.apply(r, ui(t));
  }
}
function qo(e) {
  var t = !e, r = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  $t(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), $t(r, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var fi = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Yo = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, U = Object.assign({
  appendTo: ai,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, fi, {}, Yo), Xo = Object.keys(U), Ko = function(t) {
  process.env.NODE_ENV !== "production" && pi(t, []);
  var r = Object.keys(t);
  r.forEach(function(i) {
    U[i] = t[i];
  });
};
function di(e) {
  var t = e.plugins || [], r = t.reduce(function(i, n) {
    var a = n.name, c = n.defaultValue;
    if (a) {
      var s;
      i[a] = e[a] !== void 0 ? e[a] : (s = U[a]) != null ? s : c;
    }
    return i;
  }, {});
  return Object.assign({}, e, {}, r);
}
function Go(e, t) {
  var r = t ? Object.keys(di(Object.assign({}, U, {
    plugins: t
  }))) : Xo, i = r.reduce(function(n, a) {
    var c = (e.getAttribute("data-tippy-" + a) || "").trim();
    if (!c)
      return n;
    if (a === "content")
      n[a] = c;
    else
      try {
        n[a] = JSON.parse(c);
      } catch {
        n[a] = c;
      }
    return n;
  }, {});
  return i;
}
function Pr(e, t) {
  var r = Object.assign({}, t, {
    content: si(t.content, [e])
  }, t.ignoreAttributes ? {} : Go(e, t.plugins));
  return r.aria = Object.assign({}, U.aria, {}, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? t.interactive ? null : "describedby" : r.aria.content
  }, r;
}
function pi(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var r = Object.keys(e);
  r.forEach(function(i) {
    var n = li(U, Object.keys(fi)), a = !$o(n, i);
    a && (a = t.filter(function(c) {
      return c.name === i;
    }).length === 0), pe(a, ["`" + i + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Jo = function() {
  return "innerHTML";
};
function Kt(e, t) {
  e[Jo()] = t;
}
function jr(e) {
  var t = Je();
  return e === !0 ? t.className = ni : (t.className = oi, tt(e) ? t.appendChild(e) : Kt(t, e)), t;
}
function Rr(e, t) {
  tt(t.content) ? (Kt(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Kt(e, t.content) : e.textContent = t.content);
}
function Gt(e) {
  var t = e.firstElementChild, r = Ct(t.children);
  return {
    box: t,
    content: r.find(function(i) {
      return i.classList.contains(ii);
    }),
    arrow: r.find(function(i) {
      return i.classList.contains(ni) || i.classList.contains(oi);
    }),
    backdrop: r.find(function(i) {
      return i.classList.contains(Co);
    })
  };
}
function vi(e) {
  var t = Je(), r = Je();
  r.className = Ao, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var i = Je();
  i.className = ii, i.setAttribute("data-state", "hidden"), Rr(i, e.props), t.appendChild(r), r.appendChild(i), n(e.props, e.props);
  function n(a, c) {
    var s = Gt(t), l = s.box, p = s.content, f = s.arrow;
    c.theme ? l.setAttribute("data-theme", c.theme) : l.removeAttribute("data-theme"), typeof c.animation == "string" ? l.setAttribute("data-animation", c.animation) : l.removeAttribute("data-animation"), c.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof c.maxWidth == "number" ? c.maxWidth + "px" : c.maxWidth, c.role ? l.setAttribute("role", c.role) : l.removeAttribute("role"), (a.content !== c.content || a.allowHTML !== c.allowHTML) && Rr(p, e.props), c.arrow ? f ? a.arrow !== c.arrow && (l.removeChild(f), l.appendChild(jr(c.arrow))) : l.appendChild(jr(c.arrow)) : f && l.removeChild(f);
  }
  return {
    popper: t,
    onUpdate: n
  };
}
vi.$$tippy = !0;
var Qo = 1, gt = [], Nt = [];
function Zo(e, t) {
  var r = Pr(e, Object.assign({}, U, {}, di(Lr(t)))), i, n, a, c = !1, s = !1, l = !1, p = !1, f, _, S, g = [], v = kr(at, r.interactiveDebounce), h, u = Qo++, m = null, w = Do(r.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, o = {
    // properties
    id: u,
    reference: e,
    popper: Je(),
    popperInstance: m,
    props: r,
    state: x,
    plugins: w,
    // methods
    clearDelayTimeouts: ft,
    setProps: dt,
    setContent: pt,
    show: hi,
    hide: mi,
    hideWithInteractivity: gi,
    enable: qe,
    disable: ut,
    unmount: yi,
    destroy: bi
  };
  if (!r.render)
    return process.env.NODE_ENV !== "production" && $t(!0, "render() function has not been supplied."), o;
  var C = r.render(o), y = C.popper, $ = C.onUpdate;
  y.setAttribute("data-tippy-root", ""), y.id = "tippy-" + o.id, o.popper = y, e._tippy = o, y._tippy = o;
  var M = w.map(function(d) {
    return d.fn(o);
  }), V = e.hasAttribute("aria-expanded");
  return ke(), ie(), j(), R("onCreate", [o]), r.showOnCreate && Fe(), y.addEventListener("mouseenter", function() {
    o.props.interactive && o.state.isVisible && o.clearDelayTimeouts();
  }), y.addEventListener("mouseleave", function(d) {
    o.props.interactive && o.props.trigger.indexOf("mouseenter") >= 0 && (P().addEventListener("mousemove", v), v(d));
  }), o;
  function O() {
    var d = o.props.touch;
    return Array.isArray(d) ? d : [d, 0];
  }
  function k() {
    return O()[0] === "hold";
  }
  function A() {
    var d;
    return !!((d = o.props.render) != null && d.$$tippy);
  }
  function E() {
    return h || e;
  }
  function P() {
    var d = E().parentNode;
    return d ? Po(d) : document;
  }
  function N() {
    return Gt(y);
  }
  function L(d) {
    return o.state.isMounted && !o.state.isVisible || oe.isTouch || f && f.type === "focus" ? 0 : jt(o.props.delay, d ? 0 : 1, U.delay);
  }
  function j() {
    y.style.pointerEvents = o.props.interactive && o.state.isVisible ? "" : "none", y.style.zIndex = "" + o.props.zIndex;
  }
  function R(d, b, T) {
    if (T === void 0 && (T = !0), M.forEach(function(D) {
      D[d] && D[d].apply(void 0, b);
    }), T) {
      var I;
      (I = o.props)[d].apply(I, b);
    }
  }
  function re() {
    var d = o.props.aria;
    if (d.content) {
      var b = "aria-" + d.content, T = y.id, I = Me(o.props.triggerTarget || e);
      I.forEach(function(D) {
        var W = D.getAttribute(b);
        if (o.state.isVisible)
          D.setAttribute(b, W ? W + " " + T : T);
        else {
          var G = W && W.replace(T, "").trim();
          G ? D.setAttribute(b, G) : D.removeAttribute(b);
        }
      });
    }
  }
  function ie() {
    if (!(V || !o.props.aria.expanded)) {
      var d = Me(o.props.triggerTarget || e);
      d.forEach(function(b) {
        o.props.interactive ? b.setAttribute("aria-expanded", o.state.isVisible && b === E() ? "true" : "false") : b.removeAttribute("aria-expanded");
      });
    }
  }
  function _e() {
    P().removeEventListener("mousemove", v), gt = gt.filter(function(d) {
      return d !== v;
    });
  }
  function ne(d) {
    if (!(oe.isTouch && (l || d.type === "mousedown"))) {
      var b = d.composedPath && d.composedPath()[0] || d.target;
      if (!(o.props.interactive && Mr(y, b))) {
        if (Mr(E(), b)) {
          if (oe.isTouch || o.state.isVisible && o.props.trigger.indexOf("click") >= 0)
            return;
        } else
          R("onClickOutside", [o, d]);
        o.props.hideOnClick === !0 && (o.clearDelayTimeouts(), o.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), o.state.isMounted || ue());
      }
    }
  }
  function Oe() {
    l = !0;
  }
  function ce() {
    l = !1;
  }
  function ee() {
    var d = P();
    d.addEventListener("mousedown", ne, !0), d.addEventListener("touchend", ne, be), d.addEventListener("touchstart", ce, be), d.addEventListener("touchmove", Oe, be);
  }
  function ue() {
    var d = P();
    d.removeEventListener("mousedown", ne, !0), d.removeEventListener("touchend", ne, be), d.removeEventListener("touchstart", ce, be), d.removeEventListener("touchmove", Oe, be);
  }
  function Ce(d, b) {
    $e(d, function() {
      !o.state.isVisible && y.parentNode && y.parentNode.contains(y) && b();
    });
  }
  function fe(d, b) {
    $e(d, b);
  }
  function $e(d, b) {
    var T = N().box;
    function I(D) {
      D.target === T && (Bt(T, "remove", I), b());
    }
    if (d === 0)
      return b();
    Bt(T, "remove", _), Bt(T, "add", I), _ = I;
  }
  function he(d, b, T) {
    T === void 0 && (T = !1);
    var I = Me(o.props.triggerTarget || e);
    I.forEach(function(D) {
      D.addEventListener(d, b, T), g.push({
        node: D,
        eventType: d,
        handler: b,
        options: T
      });
    });
  }
  function ke() {
    k() && (he("touchstart", He, {
      passive: !0
    }), he("touchend", st, {
      passive: !0
    })), ko(o.props.trigger).forEach(function(d) {
      if (d !== "manual")
        switch (he(d, He), d) {
          case "mouseenter":
            he("mouseleave", st);
            break;
          case "focus":
            he(Wo ? "focusout" : "blur", We);
            break;
          case "focusin":
            he("focusout", We);
            break;
        }
    });
  }
  function ot() {
    g.forEach(function(d) {
      var b = d.node, T = d.eventType, I = d.handler, D = d.options;
      b.removeEventListener(T, I, D);
    }), g = [];
  }
  function He(d) {
    var b, T = !1;
    if (!(!o.state.isEnabled || Ue(d) || s)) {
      var I = ((b = f) == null ? void 0 : b.type) === "focus";
      f = d, h = d.currentTarget, ie(), !o.state.isVisible && Mo(d) && gt.forEach(function(D) {
        return D(d);
      }), d.type === "click" && (o.props.trigger.indexOf("mouseenter") < 0 || c) && o.props.hideOnClick !== !1 && o.state.isVisible ? T = !0 : Fe(d), d.type === "click" && (c = !T), T && !I && Se(d);
    }
  }
  function at(d) {
    var b = d.target, T = E().contains(b) || y.contains(b);
    if (!(d.type === "mousemove" && T)) {
      var I = me().concat(y).map(function(D) {
        var W, G = D._tippy, De = (W = G.popperInstance) == null ? void 0 : W.state;
        return De ? {
          popperRect: D.getBoundingClientRect(),
          popperState: De,
          props: r
        } : null;
      }).filter(Boolean);
      jo(I, d) && (_e(), Se(d));
    }
  }
  function st(d) {
    var b = Ue(d) || o.props.trigger.indexOf("click") >= 0 && c;
    if (!b) {
      if (o.props.interactive) {
        o.hideWithInteractivity(d);
        return;
      }
      Se(d);
    }
  }
  function We(d) {
    o.props.trigger.indexOf("focusin") < 0 && d.target !== E() || o.props.interactive && d.relatedTarget && y.contains(d.relatedTarget) || Se(d);
  }
  function Ue(d) {
    return oe.isTouch ? k() !== d.type.indexOf("touch") >= 0 : !1;
  }
  function lt() {
    ct();
    var d = o.props, b = d.popperOptions, T = d.placement, I = d.offset, D = d.getReferenceClientRect, W = d.moveTransition, G = A() ? Gt(y).arrow : null, De = D ? {
      getBoundingClientRect: D,
      contextElement: D.contextElement || E()
    } : e, pr = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(vt) {
        var Le = vt.state;
        if (A()) {
          var wi = N(), Vt = wi.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(ht) {
            ht === "placement" ? Vt.setAttribute("data-placement", Le.placement) : Le.attributes.popper["data-popper-" + ht] ? Vt.setAttribute("data-" + ht, "") : Vt.removeAttribute("data-" + ht);
          }), Le.attributes.popper = {};
        }
      }
    }, xe = [{
      name: "offset",
      options: {
        offset: I
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !W
      }
    }, pr];
    A() && G && xe.push({
      name: "arrow",
      options: {
        element: G,
        padding: 3
      }
    }), xe.push.apply(xe, (b == null ? void 0 : b.modifiers) || []), o.popperInstance = Eo(De, y, Object.assign({}, b, {
      placement: T,
      onFirstUpdate: S,
      modifiers: xe
    }));
  }
  function ct() {
    o.popperInstance && (o.popperInstance.destroy(), o.popperInstance = null);
  }
  function de() {
    var d = o.props.appendTo, b, T = E();
    o.props.interactive && d === ai || d === "parent" ? b = T.parentNode : b = si(d, [T]), b.contains(y) || b.appendChild(y), lt(), process.env.NODE_ENV !== "production" && pe(o.props.interactive && d === U.appendTo && T.nextElementSibling !== y, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function me() {
    return Ct(y.querySelectorAll("[data-tippy-root]"));
  }
  function Fe(d) {
    o.clearDelayTimeouts(), d && R("onTrigger", [o, d]), ee();
    var b = L(!0), T = O(), I = T[0], D = T[1];
    oe.isTouch && I === "hold" && D && (b = D), b ? i = setTimeout(function() {
      o.show();
    }, b) : o.show();
  }
  function Se(d) {
    if (o.clearDelayTimeouts(), R("onUntrigger", [o, d]), !o.state.isVisible) {
      ue();
      return;
    }
    if (!(o.props.trigger.indexOf("mouseenter") >= 0 && o.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(d.type) >= 0 && c)) {
      var b = L(!1);
      b ? n = setTimeout(function() {
        o.state.isVisible && o.hide();
      }, b) : a = requestAnimationFrame(function() {
        o.hide();
      });
    }
  }
  function qe() {
    o.state.isEnabled = !0;
  }
  function ut() {
    o.hide(), o.state.isEnabled = !1;
  }
  function ft() {
    clearTimeout(i), clearTimeout(n), cancelAnimationFrame(a);
  }
  function dt(d) {
    if (process.env.NODE_ENV !== "production" && pe(o.state.isDestroyed, Ie("setProps")), !o.state.isDestroyed) {
      R("onBeforeUpdate", [o, d]), ot();
      var b = o.props, T = Pr(e, Object.assign({}, b, {}, Lr(d), {
        ignoreAttributes: !0
      }));
      o.props = T, ke(), b.interactiveDebounce !== T.interactiveDebounce && (_e(), v = kr(at, T.interactiveDebounce)), b.triggerTarget && !T.triggerTarget ? Me(b.triggerTarget).forEach(function(I) {
        I.removeAttribute("aria-expanded");
      }) : T.triggerTarget && e.removeAttribute("aria-expanded"), ie(), j(), $ && $(b, T), o.popperInstance && (lt(), me().forEach(function(I) {
        requestAnimationFrame(I._tippy.popperInstance.forceUpdate);
      })), R("onAfterUpdate", [o, d]);
    }
  }
  function pt(d) {
    o.setProps({
      content: d
    });
  }
  function hi() {
    process.env.NODE_ENV !== "production" && pe(o.state.isDestroyed, Ie("show"));
    var d = o.state.isVisible, b = o.state.isDestroyed, T = !o.state.isEnabled, I = oe.isTouch && !o.props.touch, D = jt(o.props.duration, 0, U.duration);
    if (!(d || b || T || I) && !E().hasAttribute("disabled") && (R("onShow", [o], !1), o.props.onShow(o) !== !1)) {
      if (o.state.isVisible = !0, A() && (y.style.visibility = "visible"), j(), ee(), o.state.isMounted || (y.style.transition = "none"), A()) {
        var W = N(), G = W.box, De = W.content;
        Rt([G, De], 0);
      }
      S = function() {
        var xe;
        if (!(!o.state.isVisible || p)) {
          if (p = !0, y.offsetHeight, y.style.transition = o.props.moveTransition, A() && o.props.animation) {
            var Mt = N(), vt = Mt.box, Le = Mt.content;
            Rt([vt, Le], D), Ir([vt, Le], "visible");
          }
          re(), ie(), Dr(Nt, o), (xe = o.popperInstance) == null || xe.forceUpdate(), o.state.isMounted = !0, R("onMount", [o]), o.props.animation && A() && fe(D, function() {
            o.state.isShown = !0, R("onShown", [o]);
          });
        }
      }, de();
    }
  }
  function mi() {
    process.env.NODE_ENV !== "production" && pe(o.state.isDestroyed, Ie("hide"));
    var d = !o.state.isVisible, b = o.state.isDestroyed, T = !o.state.isEnabled, I = jt(o.props.duration, 1, U.duration);
    if (!(d || b || T) && (R("onHide", [o], !1), o.props.onHide(o) !== !1)) {
      if (o.state.isVisible = !1, o.state.isShown = !1, p = !1, c = !1, A() && (y.style.visibility = "hidden"), _e(), ue(), j(), A()) {
        var D = N(), W = D.box, G = D.content;
        o.props.animation && (Rt([W, G], I), Ir([W, G], "hidden"));
      }
      re(), ie(), o.props.animation ? A() && Ce(I, o.unmount) : o.unmount();
    }
  }
  function gi(d) {
    process.env.NODE_ENV !== "production" && pe(o.state.isDestroyed, Ie("hideWithInteractivity")), P().addEventListener("mousemove", v), Dr(gt, v), v(d);
  }
  function yi() {
    process.env.NODE_ENV !== "production" && pe(o.state.isDestroyed, Ie("unmount")), o.state.isVisible && o.hide(), o.state.isMounted && (ct(), me().forEach(function(d) {
      d._tippy.unmount();
    }), y.parentNode && y.parentNode.removeChild(y), Nt = Nt.filter(function(d) {
      return d !== o;
    }), o.state.isMounted = !1, R("onHidden", [o]));
  }
  function bi() {
    process.env.NODE_ENV !== "production" && pe(o.state.isDestroyed, Ie("destroy")), !o.state.isDestroyed && (o.clearDelayTimeouts(), o.unmount(), ot(), delete e._tippy, o.state.isDestroyed = !0, R("onDestroy", [o]));
  }
}
function Ne(e, t) {
  t === void 0 && (t = {});
  var r = U.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (qo(e), pi(t, r)), No();
  var i = Object.assign({}, t, {
    plugins: r
  }), n = zo(e);
  if (process.env.NODE_ENV !== "production") {
    var a = tt(i.content), c = n.length > 1;
    pe(a && c, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = n.reduce(function(l, p) {
    var f = p && Zo(p, i);
    return f && l.push(f), l;
  }, []);
  return tt(e) ? s[0] : s;
}
Ne.defaultProps = U;
Ne.setDefaultProps = Ko;
Ne.currentInput = oe;
Object.assign({}, Kr, {
  effect: function(t) {
    var r = t.state, i = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, i.popper), r.styles = i, r.elements.arrow && Object.assign(r.elements.arrow.style, i.arrow);
  }
});
var ea = {
  mouseover: "mouseenter",
  focusin: "focus",
  click: "click"
};
function ta(e, t) {
  process.env.NODE_ENV !== "production" && $t(!(t && t.target), ["You must specity a `target` prop indicating a CSS selector string matching", "the target elements that should receive a tippy."].join(" "));
  var r = [], i = [], n = !1, a = t.target, c = li(t, ["target"]), s = Object.assign({}, c, {
    trigger: "manual",
    touch: !1
  }), l = Object.assign({}, c, {
    showOnCreate: !0
  }), p = Ne(e, s), f = Me(p);
  function _(u) {
    if (!(!u.target || n)) {
      var m = u.target.closest(a);
      if (m) {
        var w = m.getAttribute("data-tippy-trigger") || t.trigger || U.trigger;
        if (!m._tippy && !(u.type === "touchstart" && typeof l.touch == "boolean") && !(u.type !== "touchstart" && w.indexOf(ea[u.type]) < 0)) {
          var x = Ne(m, l);
          x && (i = i.concat(x));
        }
      }
    }
  }
  function S(u, m, w, x) {
    x === void 0 && (x = !1), u.addEventListener(m, w, x), r.push({
      node: u,
      eventType: m,
      handler: w,
      options: x
    });
  }
  function g(u) {
    var m = u.reference;
    S(m, "touchstart", _, be), S(m, "mouseover", _), S(m, "focusin", _), S(m, "click", _);
  }
  function v() {
    r.forEach(function(u) {
      var m = u.node, w = u.eventType, x = u.handler, o = u.options;
      m.removeEventListener(w, x, o);
    }), r = [];
  }
  function h(u) {
    var m = u.destroy, w = u.enable, x = u.disable;
    u.destroy = function(o) {
      o === void 0 && (o = !0), o && i.forEach(function(C) {
        C.destroy();
      }), i = [], v(), m();
    }, u.enable = function() {
      w(), i.forEach(function(o) {
        return o.enable();
      }), n = !1;
    }, u.disable = function() {
      x(), i.forEach(function(o) {
        return o.disable();
      }), n = !0;
    }, g(u);
  }
  return f.forEach(h), p;
}
Ne.setDefaultProps({
  render: vi
});
const ra = { class: "text-grey-140" }, ia = { class: "mb-1" }, na = {
  key: 0,
  class: "flex gap-y-2"
}, oa = { class: "shrink-0" }, aa = { class: "flex flex-col gap-2" }, sa = ["innerHTML"], la = /* @__PURE__ */ Dt({
  __name: "CompanyName",
  props: {
    dataset: {},
    i18n: {},
    service: {}
  },
  setup(e) {
    const t = e, { setHighlightLabel: r } = qr(t.service), i = H(() => {
      const { t: s } = t.i18n;
      return s;
    }), n = H(() => B.get(t.dataset, "name", "")), a = H(() => {
      const s = B.get(t.dataset, "company_history_names", []), l = t.dataset.isHighLight || t.dataset.hit_name_tag === te.history;
      return B.map(s, (p) => l ? r(p) : p);
    }), c = H(() => {
      var s;
      return a.value && ((s = a.value) == null ? void 0 : s.length);
    });
    return (s, l) => (z(), F("div", ra, [
      X("p", ia, Et(n.value), 1),
      c.value ? (z(), F("div", na, [
        X("span", oa, Et(i.value("corpTreeBiz.otherName")), 1),
        X("div", aa, [
          (z(!0), F(Br, null, Nr(a.value, (p) => (z(), F("p", {
            key: p,
            innerHTML: p
          }, null, 8, sa))), 128))
        ])
      ])) : ze("", !0)
    ]));
  }
});
const ca = { class: "tippy-container" }, ua = /* @__PURE__ */ Dt({
  __name: "DelegatePopover",
  props: {
    targets: {},
    target: {},
    tippyOptions: {},
    dataset: {},
    service: {}
  },
  setup(e) {
    const t = e, r = Qt({
      messages: {
        cn: er,
        en: tr,
        tw: ir,
        jp: rr
      }
    }), i = yt({
      arrow: !0,
      placement: "bottom-start",
      interactive: !0,
      allowHTML: !0,
      delay: [600, 200],
      appendTo: () => document.body
    }), n = yt(), a = yt(), c = H(() => t.tippyOptions ? {
      ...i.value,
      ...t.tippyOptions
    } : i.value);
    function s() {
      n.value = ta(t.targets, {
        target: t.target,
        ...c.value,
        maxWidth: 500,
        theme: "light",
        onShow(p) {
          const _ = p.reference.dataset.id, S = B.find(t.dataset, { id: _ }), g = xt(la, {
            dataset: S,
            i18n: r,
            service: t.service
          });
          zi(g, a.value), p.setContent(g == null ? void 0 : g.el);
        },
        onHidden(p) {
          p.unmount(), p.destroy();
        }
      });
    }
    function l() {
      if (n.value) {
        let p = n.value;
        B.isArray(n.value) || (p = [n.value]), B.each(p, (f) => {
          f.destroy();
        }), n.value = void 0;
      }
    }
    return Tt(() => t.targets, () => {
      l(), s();
    }), Mi(() => {
      a.value = document.createElement("div"), a.value.setAttribute("data-theme", "patsnapRD"), document.body.appendChild(a.value), s();
    }), Vi(() => {
      l(), document.body.removeChild(a.value);
    }), (p, f) => (z(), F("div", ca, [
      Te(p.$slots, "default")
    ]));
  }
}), dr = (e, t) => {
  const r = e.parent;
  r && (t(r), dr(r, t));
}, kt = (e, t) => {
  const r = e.children;
  r && r.forEach((i) => {
    t(i), i.children && kt(i, t);
  });
};
class xa {
  constructor() {
    ge(this, "disableSelectAll");
    ge(this, "opts");
    ge(this, "dataset");
    ge(this, "corpTreeHeight");
    ge(this, "siteLang");
    ge(this, "selectMode");
    ge(this, "clickLabelSelect");
    this.disableSelectAll = !1, this.opts = {
      label: "name",
      children: "children",
      isExpand: "is_expanded",
      isDisabled: "is_inactive",
      canChecked: "patent_label",
      highlight: {
        keys: []
      },
      focusVal: ""
    }, this.dataset = [], this.corpTreeHeight = 0, this.siteLang = qt.en, this.selectMode = Xe.multiple, this.clickLabelSelect = !1;
  }
  // format tree to list
  formatDataToList(t, r = 0, i = !0, n = null) {
    let a = [];
    const c = r || 0;
    return t.forEach((s) => {
      s.name = this.getDisplayName({ item: s }) || s.name, s.isHighLight = this.hasHighLightLabel({ item: s }), s.hasChildren = !!(s.children && s.children.length), s.parent = n, s.deepIndex = c, s.isVisible = i, s.isSelected = !1, s.formatedName = `TREE@"${s.name}"`, a.push(s), s.children && s.children.length && (a = [...a, ...this.formatDataToList(s.children, c + 1, s.is_expanded, s)]), B.isArray(s.name) && (s.name = s.name[0] || "");
    }), a;
  }
  // display name issue
  getDisplayName({ item: t, hitNameMap: r = br, siteLangMap: i = pn }) {
    let n = "";
    const a = t.hit_name_tag;
    if (a && a !== te.history)
      n = B.get(t, r[a], "");
    else {
      const c = i[this.siteLang];
      for (let s = 0; s < c.length; s += 1) {
        const l = c[s];
        if (t[l]) {
          n = t[l];
          break;
        }
      }
    }
    return n;
  }
  hasHighLightLabel({ item: t, hitNameMap: r = br }) {
    const i = t.hit_name_tag;
    return i && i !== te.history && B.get(t, r[i]);
  }
  // get checked nodes
  getCheckedData(t) {
    return this.dataset.filter((r) => r.isSelected ? t ? !0 : !r.parent || !r.parent.isSelected : !1);
  }
  addSelectData(t) {
    if (!t)
      return;
    const r = B.find(this.dataset, { id: t });
    r && (r.isSelected = !0);
  }
  removeSelectData(t) {
    t.isSelected = !t.isSelected, this.selectMode === Xe.multiple && (dr(t, (r) => {
      r.isSelected = !B.some(r.children, (i) => !i.isSelected && i.patent_label !== ae.inactive && !i.is_other_ans) && r.patent_label !== ae.inactive && !r.is_other_ans;
    }), kt(t, (r) => {
      r.patent_label !== ae.inactive && !r.is_other_ans && (r.isSelected = t.isSelected);
    })), this.selectChange([t]);
  }
  clearSelectedNode() {
    this.dataset.forEach((t) => {
      t.isSelected = !1;
    });
  }
  setCorpTreeDataset(t, r = !0) {
    this.dataset = r ? this.formatDataToList(t) : t;
  }
  setCorpTreeOpts(t) {
    this.opts = t;
  }
  /**
   * 选中 回显
   * @param
   */
  syncSelectedData(t, r = "id") {
    B.forEach(this.dataset, (i) => {
      i.isSelected = B.includes(t, i[r]);
    });
  }
  setSiteLang(t) {
    this.siteLang = t || qt.en;
  }
  setSelectMode(t) {
    this.selectMode = t || Xe.multiple;
  }
  validateSelect(t) {
    return !0;
  }
  selectChange(t) {
  }
  getExactMatchEvt(t) {
  }
}
const fa = { class: "patsnap-biz-corp_tree common-corporate-tree" }, da = {
  key: 0,
  class: "common-corporate-tree__check cursor-pointer pl-1"
}, pa = { class: "form-control flex items-center" }, va = ["checked"], ha = { class: "common-corporate-tree__check-label" }, Ta = /* @__PURE__ */ Dt({
  __name: "CorpTree",
  props: {
    service: {}
  },
  emits: ["selectChange", "findMatchElm"],
  setup(e, { emit: t }) {
    const r = e, { t: i } = Qt({
      messages: {
        cn: er,
        en: tr,
        tw: ir,
        jp: rr
      }
    }), n = yt(null), a = H(() => !B.some(
      r.service.dataset,
      (v) => !v.isSelected && v.patent_label !== ae.inactive && !v.is_other_ans
    )), c = H(() => r.service.dataset.filter((v) => v.isVisible)), s = H(() => r.service.corpTreeHeight ? `height:${r.service.disableSelectAll ? r.service.corpTreeHeight + 36 : r.service.corpTreeHeight}px` : "");
    function l() {
      if (!r.service.validateSelect(r.service.dataset))
        return;
      const v = !a.value;
      r.service.dataset.forEach((h) => {
        h.patent_label !== ae.inactive && !h.is_other_ans && (h.isSelected = v);
      }), t("selectChange", r.service.dataset), r.service.selectChange(r.service.dataset);
    }
    function p() {
      r.service.dataset.forEach((v) => {
        v.isSelected = !1;
      });
    }
    function f(v) {
      n.value || (n.value = v, t("findMatchElm", v), r.service.getExactMatchEvt(v));
    }
    function _(v) {
      v.is_expanded = !v.is_expanded, kt(v, (h) => {
        var u;
        h.isVisible = !!(v.is_expanded && ((u = h == null ? void 0 : h.parent) != null && u.is_expanded) && h.parent.isVisible);
      });
    }
    function S(v) {
      r.service.validateSelect([v]) && (v.isSelected = !v.isSelected, r.service.selectMode === Xe.multiple && (dr(v, (h) => {
        h.isSelected = !B.some(h.children, (u) => !u.isSelected && u.patent_label !== ae.inactive && !u.is_other_ans) && h.patent_label !== ae.inactive && !h.is_other_ans;
      }), kt(v, (h) => {
        h.patent_label !== ae.inactive && !h.is_other_ans && (h.isSelected = v.isSelected);
      })), t("selectChange", [v]), r.service.selectChange([v]));
    }
    function g() {
      n.value = null, p();
    }
    return Tt(() => r.service.dataset, () => {
      g();
    }), Tt(() => r.service.opts, () => {
      g();
    }), (v, h) => (z(), F("div", fa, [
      v.service.disableSelectAll ? ze("", !0) : (z(), F("span", da, [
        X("div", pa, [
          X("input", {
            type: "checkbox",
            checked: a.value,
            class: "th-checkbox",
            onChange: l
          }, null, 40, va),
          X("span", ha, Et(ye(i)("corpTreeBiz.checkAll")), 1)
        ])
      ])),
      xt(ye(Zt), {
        items: c.value,
        "item-size": 30,
        class: Qe([
          "common-corporate-tree__recycle-scroller",
          { "common-corporate-tree__recycle-scroller--no-select-all": v.service.disableSelectAll }
        ]),
        style: Ot(s.value),
        "key-field": "id"
      }, {
        default: St(({ item: u }) => [
          (z(), Ve(wn, {
            key: u.id,
            dataset: u,
            opts: v.service.opts,
            service: v.service,
            class: "common-corporate-tree__child",
            onItemExpand: _,
            onItemSelect: S,
            onTriggerMatch: f
          }, {
            tail: St(({ dataset: m }) => [
              Te(v.$slots, "tail", { dataset: m })
            ]),
            _: 2
          }, 1032, ["dataset", "opts", "service"]))
        ]),
        _: 3
      }, 8, ["items", "class", "style"]),
      xt(ua, {
        targets: ".common-corporate-tree",
        target: ".common-corporate-tree__child .common-corporate-tree-child__name",
        service: v.service,
        dataset: c.value
      }, null, 8, ["targets", "target", "service", "dataset"])
    ]));
  }
});
export {
  Ta as CorpTree,
  xa as CorpTreeService
};
